import { FACTORY } from '../types';
import {
  queryFactoryList,
  queryFactoryStationaryList,
  queryFactoryUserList,
  queryShareofficeBuildingList,
  queryShareofficeFloorList,
  querySysDictionary
} from '../../_db/api.service';



/* ********************************************** */

// 查詢廠區
export const queryServiceFactory = () => async (dispatch, getState) => {
  const { account: { website: { selected } } } = getState() || {};
  const { success, result } = await queryFactoryList({ areaCode: selected?.areaCode });
  if(success) {
    dispatch({
      type: FACTORY.List,
      payload: result
    });
  }
  return { success, result }
};

// 查詢廠區單位收發點
export const queryServiceUnits = (factoryId) => async (dispatch, getState) => {
  const { success, result } = await queryFactoryStationaryList({ factoryId });
  // if(success) {
  //   dispatch({
  //     type: FACTORY.Unit,
  //     payload: result
  //   });
  // };
  return { success, result };
};

// 人員搜索列表
export const queryServicePersonList = () => async (dispatch, getState) => {
  const { success, result } = await queryFactoryUserList();
  if(success) {
    dispatch({
      type: FACTORY.Person,
      payload: result
    });
  }
};


// 查詢樓棟 By FactoryId
export const queryBuildingList = (factoryId) => async (dispatch, getState) => {
  const { account: { website: { selected } } } = getState() || {};
  const { success, result } = await queryShareofficeBuildingList({ factoryId });
  if(success) {
    dispatch({
      type: FACTORY.Build,
      payload: result
    });
  }
  return { success, result }
};

// 查詢樓層 By BuildId
export const queryFloorList = (buildId) => async (dispatch, getState) => {
  const { account: { website: { selected } } } = getState() || {};
  const { success, result } = await queryShareofficeFloorList({ buildId });
  if(success) {
    dispatch({
      type: FACTORY.Floor,
      payload: result
    });
  }
  return { success, result }
};

// 重置樓層
export const resetFloorList = () => async (dispatch, getState) => {
  dispatch({
    type: FACTORY.Floor,
    payload: []
  });
};

// 數據字典
export const querySysDictionaryList = (dictCode) => async (dispatch, getState) => {
  const { success, result } = await querySysDictionary(dictCode);
  if(success) {
    dispatch({
      type: dictCode,
      payload: result
    });
  }
};